import { cn } from "@/libs/cn";

export default function ListLoader(props) {

  const liteRingColor = 'gray-950';
  const darkRingColor = 'gray-100';
  const commanCss     = 'absolute border-4 rounded-full';
  const colorXCss     = `border-t-transparent border-b-transparent border-r-${liteRingColor} border-l-${liteRingColor} dark:border-r-${darkRingColor} dark:border-l-${darkRingColor}`;
  const colorYCss     = `border-l-transparent border-r-transparent border-t-${liteRingColor} border-b-${liteRingColor} dark:border-t-${darkRingColor} dark:border-b-${darkRingColor}`;
  const outerSizeCss  = 'top-0 left-0 w-16 h-16';
  const innerSizeCss  = 'top-3 left-3 w-10 h-10';

  return (
    <div class="flex items-center justify-center w-full h-full">
      <div class="relative h-20">
        {/* Outer double ring */}
        <div class={cn(
          commanCss,
          colorYCss,
          outerSizeCss,
          "animate-spin"
        )}></div>
        <div class={cn(
          commanCss,
          colorXCss,
          outerSizeCss,
          "animate-spin-reverse"
        )}></div>

        {/* Inner double ring */}
        <div class={cn(
          commanCss,
          colorYCss,
          innerSizeCss,
          "animate-spin-slow"
        )}></div>
        <div class={cn(
          commanCss,
          colorXCss,
          innerSizeCss,
          "animate-spin-reverse-slow"
        )}></div>
      </div>
    </div>
  );
}
